
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-quote",
      function () {
        return require("private-next-pages/smart-quote/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-quote"])
      });
    }
  